import React, { useEffect, useRef, useState } from "react";
import "./request.scss";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import abs1 from "../../assets/Group39264.png";
import abs2 from "../../assets/white39265.png";
import Header2 from "../../components/Header/Header2";
import { postRequest } from "../../utils/axiosrequest";
import { Country } from "../../utils/Country";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
const Request = () => {
  useEffect(() => {
    document.title = "Request Invite | Ballers";
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  const sports = ["Football", "Cricket", "e-Sports", "Pickleball", "Others"];
  const token = "Bearer YmFsbGVyc29mZmljaWFsbGl2ZXdlYnNpdGV0b2tlbjIwMjQ=";
  const navigate = useNavigate();
  const [Code, setCode] = useState("+91");
  const [hidden, sethidden] = useState(true);
  const [sporthidden, setsporthidden] = useState(true);
  const [investmenthidden, setinvestmenthidden] = useState(true);
  const [User, setUser] = useState({
    user_name: "",
    country_code: Code,
    phone_no: "",
    email_id: "",
    company_name: "",
    social_media_handle: "",
    interested_sports: [],
    investment_amount_capacity: "",
    status: "under_review",
  });
  const handlechange = (e) => {
    const value = e.target.value;
    setUser({ ...User, [e.target.name]: value });
  };
  const handleCheckboxChange = (e) => {
    // console.log("hello", e.target.value);
    const name = e.target.value;
    const updatedSports = [...User.interested_sports];

    if (updatedSports.includes(name)) {
      setUser({
        ...User,
        interested_sports: updatedSports.filter((sport) => sport !== name),
      });
    } else {
      setUser({
        ...User,
        interested_sports: [...updatedSports, name],
      });
    }
  };
  const handleformSubmit = async (e) => {
    try {
      e.preventDefault();
      const endpoint = `auth/apply_for_membership`;
      if (User.interested_sports.length === 0) {
        toast.error("Please fill Interested Sports");
      } else {
        const res = await postRequest(endpoint, User, token);
        if (res) {
          setUser({
            user_name: "",
            country_code: Code,
            phone_no: "",
            email_id: "",
            company_name: "",
            social_media_handle: "",
            interested_sports: [],
            investment_amount_capacity: "",
            status: "under_review",
          });
          // console.log(res);
          const messageParts = res.split("!");
          const firstPart = messageParts[0] + "!";
          const secondPart = messageParts[1].trim();
          toast.success(
            <div>
              {firstPart} <br />
              {secondPart}
            </div>
          );
          navigate("/");
        }
        // console.log(res);
      }
    } catch (error) {
      toast.error(error.response.data.detail);
      // console.log(error);
    }
  };
  const dropdownRef = useRef(null);
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setsporthidden(true);
        setinvestmenthidden(true);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  const handlechangeInvestmen = (e) => {
    setUser({ ...User, investment_amount_capacity: e.target.value });
  };

  return (
    <div className="request_section">
      <div className="request_content">
        <Header2 />
        <div className="form">
          <div className="title">
            <h2>
              <div className="abs1">
                <img src={abs1} alt="" />
              </div>
              Playground for the world’s <span>0.01%</span>
            </h2>
            <div className="info">
              <div className="rectangle"></div>
              <p>
                Rare opportunities. Rare access. Rarer people.
                <div className="abs2">
                  <img src={abs2} alt="" />
                </div>
              </p>
            </div>
          </div>
          <div className="form_wrapper">
            <form onSubmit={handleformSubmit}>
              <label htmlFor="user_name" className="input-group">
                Name
              </label>
              <input
                type="text"
                id="user_name"
                name="user_name"
                placeholder="Let us know your full name."
                value={User.user_name}
                required
                onChange={handlechange}
              />
              <label htmlFor="email_id" className="input-group email">
                Email
              </label>
              <input
                type="email"
                id="email_id"
                name="email_id"
                placeholder="Please provide your email address"
                required
                value={User.email_id}
                onChange={handlechange}
              />
              <label htmlFor=" company_name " className="input-group email">
                Company Name
              </label>
              <input
                type="text"
                id="company_name"
                name="company_name"
                placeholder="Please provide Company Name (if any)"
                required
                value={User.company_name}
                onChange={handlechange}
              />
              <label htmlFor="phonenumber" className="input-group">
                Phone number
              </label>
              <div className="phonenumber">
                <div className="code" onClick={() => sethidden(!hidden)}>
                  {Code}
                  {hidden ? (
                    <KeyboardArrowDownIcon />
                  ) : (
                    <KeyboardArrowUpIcon style={{ color: "lightgreen" }} />
                  )}
                </div>
                {hidden ? (
                  <></>
                ) : (
                  <div className="countrycode">
                    {Country.map((country) => {
                      return (
                        <div
                          key={country.code}
                          onClick={() => {
                            sethidden((prev) => !prev);
                            setCode(country.dial_code);
                            setUser({
                              ...User,
                              country_code: country.dial_code,
                            });
                          }}
                        >
                          {country.name + " " + country.dial_code}
                        </div>
                      );
                    })}
                  </div>
                )}

                <input
                  type="text"
                  id="phone_no"
                  name="phone_no"
                  pattern="[0-9]*"
                  placeholder="Please provide your Phone number"
                  required
                  value={User.phone_no}
                  onChange={handlechange}
                />
              </div>
              <label htmlFor="social_media_handle" className="input-group">
                Social Media Handle
              </label>
              <input
                type="text"
                id="social_media_handle"
                name="social_media_handle"
                placeholder="LinkedIn/Instagram"
                required
                pattern="https://.*"
                value={User.social_media_handle}
                onChange={handlechange}
              />
              <label htmlFor="Interestedsports" className="inv-sport">
                Interested sports
              </label>
              <div className="dropdown">
                <div
                  className="sports"
                  onClick={() => setsporthidden(!sporthidden)}
                >
                  <input
                    type="text"
                    value={User.interested_sports.join(", ") || ""}
                    placeholder="Select Sports"
                    style={{ marginBottom: "0" }}
                  />

                  {sporthidden ? (
                    <div className="downarrow">
                      <KeyboardArrowDownIcon />
                    </div>
                  ) : (
                    <div className="downarrow">
                      <KeyboardArrowUpIcon style={{ color: "lightgreen" }} />
                    </div>
                  )}
                </div>
                {sporthidden ? (
                  <></>
                ) : (
                  <div className="reqSportOpt" ref={dropdownRef}>
                    {sports.map((sport) => (
                      <div className="reqSportOptInner" key={sport}>
                        <input
                          type="checkbox"
                          name={sport}
                          value={sport}
                          checked={User.interested_sports.includes(sport)}
                          onChange={handleCheckboxChange}
                        />{" "}
                        <p>{sport.charAt(0).toUpperCase() + sport.slice(1)} </p>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              <label htmlFor="investment_amount_capacity" className="inv-amt">
                Investment amount capacity
              </label>
              <div className="dropdown">
                <div
                  className="sports"
                  onClick={() => setinvestmenthidden(!investmenthidden)}
                >
                  <input
                    type="text"
                    name="investment_amount_capacity"
                    id="investment_amount_capacity"
                    required
                    value={User.investment_amount_capacity}
                    onChange={handlechangeInvestmen}
                    placeholder="Select Investment Amount Capacity"
                    style={{ marginBottom: "0" }}
                  />

                  {investmenthidden ? (
                    <div className="downarrow">
                      <KeyboardArrowDownIcon />
                    </div>
                  ) : (
                    <div className="downarrow">
                      <KeyboardArrowUpIcon style={{ color: "lightgreen" }} />
                    </div>
                  )}
                </div>
                {investmenthidden ? (
                  <></>
                ) : (
                  <div className="reqSportOpt" ref={dropdownRef}>
                    <div className="reqSportOptInnerInv">
                      <p
                        onClick={() =>
                          setUser({
                            ...User,
                            investment_amount_capacity: "Between $100k - $500k",
                          })
                        }
                      >
                        Between $100k - $500k
                      </p>
                      <p
                        onClick={() =>
                          setUser({
                            ...User,
                            investment_amount_capacity: "Between $500k - $5M",
                          })
                        }
                      >
                        Between $500k - $5M
                      </p>
                      <p
                        onClick={() =>
                          setUser({
                            ...User,
                            investment_amount_capacity: "Above $5M",
                          })
                        }
                      >
                        Above $5M
                      </p>
                    </div>
                  </div>
                )}
              </div>
              <button type="submit"> Request Invite</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Request;
